import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import {
  deleteItemCollection,
  editCollection,
} from "../../../../api/ApiCollection";
import { TblCollection } from "../../../../model/TblComboSetCollection";

const DeleteView = ({ idItem, onSearch, formData, idBST }: DeleteProduct) => {
  const handleDeleteProductAds = async () => {
    if (idItem && idItem?.length > 0) {
      await deleteItemCollection({
        specialId: idBST,
        ids: idItem,
      });
      modals.closeAll();
      onSearch && onSearch();
    }
  };

  return (
    <div>
      <Text size="24px" mt={10} mb={10}>
        Bạn có chắc chắn muốn xóa các sản phẩm này khỏi bộ sưu tập?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="#3598dc"
          onClick={handleDeleteProductAds}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
        <Button
          type="button"
          color="#3598dc"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
      </Group>
    </div>
  );
};

type DeleteProduct = {
  idItem?: number[];
  onSearch?: () => void;
  formData?: TblCollection;
  idBST?: number; //id bộ sưu tập
};

export default DeleteView;
